import { Command } from 'commander';
import { createVaultInitCommand } from './init.js';
import { createVaultAddCommand } from './add.js';
import { createVaultUpdateCommand } from './update.js';
import { createVaultDeleteCommand } from './delete.js';
import { createVaultListCommand } from './list.js';
import { createVaultSearchCommand } from './search.js';
import { createVaultShowCommand } from './show.js';
import { createVaultRenderCommand } from './render.js';
import { createVaultRevealCommand } from './reveal.js';
import { createVaultSshAsCommand, createVaultSshCommand, createVaultSshRoCommand } from './ssh.js';
import { createVaultSyncCommand } from './sync.js';
import { createVaultGuideCommand } from './guide.js';
import {
    createVaultTrustCommand,
    createVaultTrustStatusCommand,
    createVaultUntrustCommand,
} from './trust.js';

export function createVaultCommand(): Command {
    const cmd = new Command('vault')
        .alias('v')
        .description('E2E-encrypted secure context vault for coding agents');

    cmd.addCommand(createVaultInitCommand());
    cmd.addCommand(createVaultAddCommand());
    cmd.addCommand(createVaultUpdateCommand());
    cmd.addCommand(createVaultDeleteCommand());
    cmd.addCommand(createVaultListCommand());
    cmd.addCommand(createVaultSearchCommand());
    cmd.addCommand(createVaultShowCommand());
    cmd.addCommand(createVaultRenderCommand());
    cmd.addCommand(createVaultRevealCommand());
    cmd.addCommand(createVaultSshCommand());
    cmd.addCommand(createVaultSshAsCommand());
    cmd.addCommand(createVaultSshRoCommand());
    cmd.addCommand(createVaultSyncCommand());
    cmd.addCommand(createVaultGuideCommand());
    cmd.addCommand(createVaultTrustCommand());
    cmd.addCommand(createVaultUntrustCommand());
    cmd.addCommand(createVaultTrustStatusCommand());

    cmd.action(() => {
        cmd.help();
    });

    return cmd;
}
